import React, { useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const SimpleToaster = ({failed, success, stateNotification, message}) => {

    const optionsToast = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
        } 

  useEffect(() =>{
    if(stateNotification && success) toast.success('🚀 ' + message, optionsToast );
    if(stateNotification && failed) toast.error(message, optionsToast);
  }, [message])

 
     return (
        
        <ToastContainer
        className={'toaster'}
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      );

}

export default SimpleToaster